



























import { defineComponent } from '@vue/composition-api';

import RegisterNewUserMenu from './RegisterNewUserMenu.vue';
import UpdateUser from './UpdateUser.vue';
import UserMetricsMenu from './UserMetricsMenu.vue';

import {
  registerNewUserMenu,
  updateUserMenu,
  userMetricsMenu,
} from '../state';

export default defineComponent({
  name: 'User',
  components: {
    RegisterNewUserMenu,
    UpdateUser,
    UserMetricsMenu,
  },
  setup() {
    return {
      registerNewUserMenu,
      updateUserMenu,
      userMetricsMenu,
    };
  },
});
